import React from 'react';
import ParticipantStatusSummaryCard from './components/ParticipantStatusSummaryIndex.jsx';

const ParticipantStatusSummary = () => <ParticipantStatusSummaryCard />;

export default ParticipantStatusSummary;
